export default {
    init() { },
    addAlert({ commit, dispatch }, { color = 'primary', text, timeout = 5000 }) {
        commit('ADD_ALERT', { color, text })
        setTimeout(() => dispatch('clearAlerts'), timeout)
    },
    clearAlerts({ commit }) {
        commit('CLEAR_ALERTS', [])
    },
}